const initialState = {
  name: null,
  email: null,
  role: null,
  titles: [],
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return {
        ...state,
        name: action.data.name || state.name,
        email: action.data.email || state.email,
        role: action.data.role || state.role,
        titles: Array.isArray(action.data.titles) ? action.data.titles : state.titles,
      };

    default:
      return state;
  }
};

export default profile;
